import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { RegionProvider } from '../../shared/providers/region.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
roleList:any = [];
showTermsCond:boolean = false;
termsConditions:any;
editTC ={
  user_role_id :'',
  about_the_content :'',
  terms_and_cond_content :'',
  privacy_policy :'',
  customer_service_content :'',
  lang:'',
  program_id:1
}
formGroup:FormGroup;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public regionProviders: RegionProvider,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService

  ) { }
  ngOnInit() {
    this.getLanguages()
    this.getRoles();
  }
  getRoles(){
    this.apiService.get(this.apiConfig.getRoleId).subscribe((res:any)=>{
      console.log(res)
      this.roleList = res.data;
      console.log("roleList",this.roleList);
    },(err:any)=>{
      this.toast.Error(err);
    })
  }
  selectRole(e){
    this.getTermsConditions(e);
    this.showTermsCond = true;
  }
  getTermsConditions(id){
    this.apiService.get(this.apiConfig.getTermsConditions+`&user_role_id=${id}`).subscribe((res:any)=>{
      console.log(res);
      this.termsConditions = res.data
      if(this.termsConditions != 0){
        this.editTC = this.termsConditions
        this.editTC.about_the_content = this.termsConditions.about_content
      }else{
        this.editTC = this.editTC;
      }
    },(err:any)=>{
      this.toast.Error(err);
    })
  }
  languages:any;
  getLanguages(){
    this.apiService.get(this.apiConfig.getLanguages).subscribe((res:any)=>{
      this.languages = res.data
      console.log(this.languages)
    },(err:any)=>{
      this.toast.Error(err)
    })
  }
  submit(data){
    this.apiService.post(this.apiConfig.editTermsConditions,data).subscribe((res:any)=>{
      console.log(res);
      this.showTermsCond = false;
      this.editTC.user_role_id=''
      this.editTC.about_the_content=''
      this.editTC.customer_service_content=''
      this.editTC.privacy_policy=''
      this.editTC.terms_and_cond_content=''
      this.editTC.program_id =1
      this.editTC.lang = ''
      this.toast.Success(res.body.data);
    })
  }
  // ADD TERMS 
  addRole(modal){
    this.modalService.open(modal,{size:'xl'});
    this.formGroup = this.fb.group({
      user_role_id: new FormControl(''),
      about_content: new FormControl (''),
      terms_and_cond_content: new FormControl(''),
      privacy_policy: new FormControl(''),
      customer_service_content: new FormControl(''),
      program_id: new FormControl('1'),
      lang: new FormControl('')
    });
  }
  addTerms(data){
    this.apiService.post(this.apiConfig.addTC,data).subscribe((res:any)=>{
      console.log(res)
      this.modalService.dismissAll()
      this.toast.Success(res.body.data)
    },(err:any)=>{
      this.toast.Error(err)
    })
  }


}
